import { useMutation } from '@tanstack/react-query'
import { deleteCreative } from 'supabase/creatives'
import { queryClient } from 'utils'

export const useDeleteCreative = (
  onSuccess: () => any
) => {
  const mutation = useMutation({
    mutationFn: (id: string) => {
      return deleteCreative(id)
    },
    onSuccess: (data: any, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['creatives'],
      })
      queryClient.invalidateQueries({
        queryKey: ['creative', variables],
      })

      onSuccess()
    },
  })

  return mutation
}